// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"ToolTip_tooltip__Ktde_","tooltiptext":"ToolTip_tooltiptext__XPbEP","active":"ToolTip_active__XR_Br"};